import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const getServiceSlice = createAsyncThunk(
    "service/getService",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post("/service/getService", data, {
                headers: {
                    "Content-Type": "application/json",
                    token: data.token
                }
            });
            return response.data
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message)
        }
    }
);

export const getPathologyServiceByClinic = createAsyncThunk(
    "service/getPathologyServiceByClinic",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post("/service/getPathologyServiceByClinic", data, {
                headers: {
                    "Content-Type": "application/json",
                    token: data.token
                }
            });
            return response.data
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message)
        }
    }
);

export const getHealthScreeningServiceByClinic = createAsyncThunk(
    "service/getHealthScreeningServiceByClinic",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post("/service/getHealthScreeningServiceByClinic", data, {
                headers: {
                    "Content-Type": "application/json",
                    token: data.token
                }
            });
            return response.data
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message)
        }
    }
);

const initialState = {
    loading: false,
    services: [],
    pathologyServices: [],
    healthScreeningServices: [],
};

const serviceSlice = createSlice({
    name: 'service',
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(getServiceSlice.pending, (state) => {
                state.loading = true;
            })
            .addCase(getServiceSlice.fulfilled, (state, action) => {
                state.loading = false;
                state.services = action.payload.result.list
            })
            .addCase(getServiceSlice.rejected, (state, action) => {
                state.loading = false;
                state.searchServiceErrorMessage = action?.payload?.result?.message;
            })
            .addCase(getPathologyServiceByClinic.pending, (state) => {
                state.loading = true;
            })
            .addCase(getPathologyServiceByClinic.fulfilled, (state, action) => {
                state.loading = false;
                state.pathologyServices = action.payload.result.list
            })
            .addCase(getPathologyServiceByClinic.rejected, (state, action) => {
                state.loading = false;
                state.searchServiceErrorMessage = action?.payload?.result?.message;
            })
            .addCase(getHealthScreeningServiceByClinic.pending, (state) => {
                state.loading = true;
            })
            .addCase(getHealthScreeningServiceByClinic.fulfilled, (state, action) => {
                state.loading = false;
                if(action.payload.success === false) {
                    state.searchServiceErrorMessage = action.payload.result.message;
                    state.healthScreeningServices = [];
                } else {
                    state.healthScreeningServices = action.payload.result.list;
                    state.searchServiceErrorMessage = null;
                }
            })
            .addCase(getHealthScreeningServiceByClinic.rejected, (state, action) => {
                state.loading = false;
                state.searchServiceErrorMessage = action.payload.result?.message;
            })
    }
});

export default serviceSlice.reducer;